import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import { useNavigate } from 'react-router-dom';

function ScheduleAnalytics() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Schedule Analytics"
        subtitle="Resource Utilization & Appointments"
        backButton
        onBack={() => navigate('/dashboard')}
        backTitle="Back to Dashboard"
      />
      <main className="max-w-full mx-auto px-6 py-8">
        <div className="bg-white rounded-lg shadow p-12 text-center">
          <div className="text-6xl mb-4">📅</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Schedule Analytics</h2>
          <p className="text-gray-600 mb-4">Resource utilization, appointment stats, and scheduling efficiency metrics</p>
          <button onClick={() => navigate('/ops/engineer-dispatch')} className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-semibold">
            View Dispatch Board
          </button>
        </div>
      </main>
    </div>
  );
}

export default ScheduleAnalytics;
